import axios from 'axios';
import { get } from 'lodash';

import UserCognitoService from './controllers/user/UserCognitoService';

const { VITE_API_ENDPOINT, API_TIME_OUT } = import.meta.env;

const ApiClient = axios.create({
  baseURL: `${VITE_API_ENDPOINT}`,
  timeout: (API_TIME_OUT && parseInt(API_TIME_OUT, 10)) || 600000,
});

ApiClient.interceptors.request.use(
  (config: any) => {
    const authorizationData = UserCognitoService.cognitoUser?.getSignInUserSession()?.getAccessToken().getJwtToken();
    if (authorizationData) {
      config.headers.Authorization = `Bearer ${authorizationData}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

ApiClient.interceptors.response.use(
  (response: any) => {
    return response.data;
  },
  (error: any) => {
    console.log("🚀 ~ error:", error)
    const message = get(error, 'response.data.message');

    if (message === 'token_invalid') {
      localStorage.removeItem('identifiedAt');
      // window.location.reload();
      // UserCognitoService.logout();
    }

    return Promise.reject(error);
  },
);

export default ApiClient;
